// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-t757b";
var _4 = "contentRight-1EOo0";
var _5 = "iconWrapper-2MHTN";
var _6 = "cdnIcon-1qHEB";
var _7 = "title-15Ta6";
var _8 = "successIcon-eruzG";
var _9 = "content-kPbHz";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "contentRight", _5 as "iconWrapper", _6 as "cdnIcon", _7 as "title", _8 as "successIcon", _9 as "content" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "contentRight": _4, "iconWrapper": _5, "cdnIcon": _6, "title": _7, "successIcon": _8, "content": _9 }
